export default function ReadMore(element, readMoreLabel, readLessLabel, ellipsis) {
  const originalNodes = Array.from(element.childNodes).map(n => n.cloneNode(true));
  const originalText = element.textContent;
  let trigger;

  if (originalText.length <= 150) return;

  const limited = originalText.substring(0, 150).replace(/[-,.\s]$/, '') + ellipsis;

  const restoreOriginal = () => {
    element.replaceChildren(...originalNodes.map(n => n.cloneNode(true)));
  };

  const showTruncated = () => {
    const p = document.createElement('p');
    p.textContent = limited;
    element.replaceChildren(p);
  };

  const toggle = () => {
    trigger?.remove();
    showTruncated();
    trigger = document.createElement('a');
    trigger.href = '#';
    trigger.className = 'readmoreless readmoreless--more js-readmoreless';
    trigger.textContent = readMoreLabel;
    element.insertAdjacentElement('afterend', trigger);

    trigger.addEventListener('click', e => {
      e.preventDefault();
      if (trigger.classList.contains('readmoreless--more')) {
        restoreOriginal();
        trigger.classList.replace('readmoreless--more', 'readmoreless--less');
        trigger.textContent = readLessLabel;
      } else {
        showTruncated();
        trigger.classList.replace('readmoreless--less', 'readmoreless--more');
        trigger.textContent = readMoreLabel;
      }
    });
  };

  const beforePrint = () => {
    restoreOriginal();
    trigger?.remove();
    trigger = null;
  };

  window.matchMedia?.('print').addEventListener('change', mql => {
    mql.matches ? beforePrint() : toggle();
  });
  window.addEventListener('beforeprint', beforePrint);
  window.addEventListener('afterprint', toggle);

  toggle();
}
